import React from "react";
import UsersDataTable from "../../../admin/users/UsersDataTable";

class ClientUsersPage extends React.Component {
  render() {
    return (
      <div className="sub-content">
        <UsersDataTable parent="ClientUsersPage" />
      </div>
    );
  }
}

export default ClientUsersPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientUsers/ClientUsersPage.js